import { Font } from '@react-pdf/renderer';

/** @type {import('@react-pdf/types').SingleLoad} */
const font = {
  family: 'Garamond',
  fontWeight: 400,
  format: 'truetype',
  src: 'https://res.cloudinary.com/bottlebooks/raw/upload/urbanihof.at/fonts/EBGaramond-Regular.ttf',
};

Font.register(font);

const style = {
  fontFamily: font.family,
  fontWeight: Number(font.fontWeight),
};
export default style;
